<script setup lang="ts">
import { VisibilitySpectrum } from '@/core/Common'
import Spectrum from '@/core/resources/Spectrum'

const publicUrl = import.meta.env.VITE_API_URL

defineProps({
  spectrum: {
    type: Object as () => Spectrum,
    required: true
  }
})
const selected = defineModel<boolean>()
</script>

<template>
  <tr
    :class="{
      selected: selected,
      published: spectrum.visibility === VisibilitySpectrum.DISPLAY,
      hidden: spectrum.visibility === VisibilitySpectrum.HIDDEN,
      ready: spectrum.visibility === VisibilitySpectrum.READY
    }">
    <td>
      <input type="checkbox" v-model="selected" />
    </td>
    <td class="visibility">
      <span>{{ spectrum.visibility }}</span>
    </td>
    <td class="short-name">
      <a :href="publicUrl + '/spectra/' + spectrum.calc_key + '/'">
        <span>{{ spectrum.short_name }}</span>
      </a>
    </td>
    <td class="collection-name">
      <span>{{ spectrum.collection_name }}</span>
    </td>
    <td class="version">
      <span>{{ spectrum.version ? spectrum.version : 'N/A' }}</span>
    </td>
  </tr>
</template>

<style scoped lang="scss">
@import '@/assets/styles/tableline.scss';

tr {
  &.published {
    background-color: var(--theme-success);
  }

  &.hidden {
    background-color: var(--theme-error);
  }

  &.ready {
    background-color: var(--theme-warning);
  }

  &:hover {
    background-color: var(--theme-panel-secondary);
  }
}

td {
  &.visibility {
    width: 100px;
  }

  &.short-name {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    a {
      color: var(--theme-color);
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  &.collection-name {
    width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &.version {
    width: 100px;
  }
}
</style>
